import {
	AfterViewChecked,
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	HostBinding,
	HostListener,
	OnDestroy,
	OnInit,
	Renderer2,
	ViewEncapsulation,
	effect,
	inject,
	signal,
} from '@angular/core';
import { SidebarConfigService } from '../../core/service/app/sidebar-config.service';
import { } from '@angular/common/http';
import { NzIconService } from 'ng-zorro-antd/icon';
import { IconSVG } from '../../core/helpers/icons';
import { KeycloakConfig } from '../../core/keycloak/keycloak-config';
import { Helpers } from '../../core/helpers';
import { Subscription, filter, map } from 'rxjs';
import { MeService } from '../../core/service/api/me.service';
import { Me } from '../../core/model/me/me';
import { NzSelectSizeType } from 'ng-zorro-antd/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	ActivatedRoute,
	NavigationEnd,
	Router,
	RouterModule,
} from '@angular/router';
import { LayoutModule } from '../../layout/layout.module';
import { LocationGroup } from '../../core/model/location_group/location_group';
import { CommonModule, DOCUMENT } from '@angular/common';
import { LocationsService } from '../../core/service/api/location.service';
import {
	LocationS,
	LocationSListData,
} from '../../core/model/location/location';
import moment from 'moment';
import { FilterChangeService } from '../../core/service/api/filter-change.service';
import { LocationData } from '../../core/model/location/location-data';
import { ThemeService } from '../../core/service/app/theme.service';
import { DarkModeService } from '../../core/service/app/darkmode.service';

import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environment/environment.prod';
import { TenantService } from '../../core/service/api/tenant.service';
import { Tenant } from '../../core/model/tenant/tenant';
import { LocationGroupService } from '../../core/service/api/location-group.service';
import { Store } from '@ngrx/store';
import { setFilter } from '../../core/store/filter/filter.actions';
import { HiddenSectionsKonstants } from '../../core/model/constant/hidden_sections_k/hidden_sections_k';

type PersistedSidebarFilters = {
	tenant: string;
	locationGroup: string;
	locationId: string;
	timeRange: string;
	since: string;
	until: string;
};

@Component({
	selector: 'app-base',
	templateUrl: './base.component.html',
	styleUrls: ['./base.component.less'],
	// encapsulation: ViewEncapsulation.None,
	// imports:[],
	// standalone: true,
	// imports:[]
})
/**
 * Componente base della dashboard principale.
 *
 * Gestisce la logica di layout, sidebar, dark mode, selezione tenant/location/location group,
 * e la propagazione dei filtri globali tramite NgRx Store. Tutti i parametri di filtro
 * (since, until, location_id, time_range, tenant, location_group, location) sono sincronizzati
 * con lo stato globale e propagati ai componenti figli.
 *
 * Best practice: tutte le subscription vengono gestite e rimosse in ngOnDestroy.
 *
 * @remarks
 * - Utilizza NgRx Store per la gestione centralizzata dei filtri globali.
 * - Sostituisce la logica legacy basata su LocalStorageService e FilterChangeService.
 * - Gestisce anche la modalità dark/light e la responsività della sidebar.
 */
export class BaseComponent implements OnInit, OnDestroy, AfterViewInit {
	/**
	 * Sottoscrizioni attive per la gestione del ciclo di vita e cleanup.
	 */
	private _subscriptions: Array<Subscription> = [];
	/**
	 * Stato di apertura/chiusura della sidebar.
	 */
	isCollapsed = false;
	/**
	 * Larghezza attuale della sidebar.
	 */
	sideBarWidth: number = 0;
	/**
	 * Larghezza della sidebar (usata nel template per [nzWidth]).
	 */
	public width: number = 260;
	/**
	 * Indica se la freccia della sidebar è invertita (usata nel template per [nzReverseArrow]).
	 */
	public isReverseArrow: boolean = false;
	/**
	 * Dimensione dei select (usata nel template per [nzSize]).
	 */
	public size: NzSelectSizeType = 'default';
	/**
	 * Parametri di filtro globali sincronizzati con NgRx Store.
	 * @property _since Data di inizio periodo
	 * @property _until Data di fine periodo
	 * @property _location_id ID della location selezionata
	 * @property _timeRange Intervallo temporale selezionato
	 * @property _tenant Tenant selezionato
	 * @property _locationGroup Gruppo location selezionato
	 * @property _locationID Location selezionata
	 */
	_since: string = Helpers.getSince();
	_until: string = Helpers.getUntil();
	_location_id: string = Helpers.getDefaultLocation();
	_timeRange: string =
		Helpers.getSavedTimeRange() || Helpers.getRangeMode() || 'LAST_7_DAYS';
	_tenant: string = Helpers.getTenantIDInLS();
	_locationGroup: string =
		localStorage.getItem('location_group_id_selected') ||
		Helpers.getDefaultLocationGroup();
	_locationID: string =
		localStorage.getItem('location_id_selected') ||
		Helpers.getDefaultLocation();
	date = null;
	_queryTime: string = '';
	_drawerVisible = false;
	_brandIconName: string = '';
	_showRangePicker: boolean = false;
	listTimeRange = Helpers.timeRangeEnum();
	currentRoute: string = '';
	_showMenu: boolean = true;
	// ID della località selezionata
	_bodyToPass: LocationData | any;
	// darkmode
	themeSwitcher: boolean = true;
	availableDarkModeClasses: string[] = ['light', 'dark'];
	availableSections: Array<String> = [];
	// availableSections: string[] = ['cashback'];
	currentDarkModeClassIdx: number = 0;
	bodyClass!: string;
	_showWEEKSelect: boolean = false;
	mode: string = '';
	selectedDate: Date | null = null;
	_showSelects: boolean = false;
	_showMonitoring: boolean = false;
	/**
	 * Periodo da mostrare, può essere impostato per scopi di visualizzazione.
	 */
	_periodToShow: string = '';
	_locationName: string = '';
	_locationGroupName: string = '';
	// _checkAllLocation  = Helpers.getDefaultLocation();
	_isVisible: boolean = false;
	_tenantsList: Array<Tenant> = [];

	openMap: { [name: string]: boolean } = {
		sub1: false,
		sub2: false,
		sub3: false,
		sub4: false,
		sub5: false,
		sub6: false,
		sub2_1: true,
		sub2_2: true,
		sub7: false,
	};
	openMap2: { [name: string]: boolean } = {
		sub2_1: true,
		sub2_2: true,
	};
	openMap3: { [name: string]: boolean } = {
		sub3_1: true,
		sub3_2: true,
	};
	Helpers = Helpers;

	/**
	 * Lista dei gruppi location disponibili per la selezione.
	 */
	public listLocationsGroups: Array<LocationGroup> = [];
	/**
	 * Lista delle location disponibili per la selezione.
	 */
	public listLocationsID: Array<LocationS> = [];
	/**
	 * Stato di apertura/chiusura della sidebar (per la responsività).
	 */
	public sidebar: boolean = false;
	public sidebarReady: boolean = false;
	_hiddenSectionsIds: string[] = [];
	public hiddenSectionsIds: string[] = [];
	HiddenSectionsKonstants = HiddenSectionsKonstants;

	updateHiddenSectionsIds() {
		const hiddenSectionsRaw = localStorage.getItem('hidden_sections');
		this.hiddenSectionsIds = hiddenSectionsRaw
			? JSON.parse(hiddenSectionsRaw).map((s: any) => s.id)
			: [];
		// sidebarReady solo se listLocationsGroups è popolata
		// this.sidebarReady = this.listLocationsGroups.length > 0;
		this.chRef.detectChanges();
	}

	constructor(
		public _sidebarService: SidebarConfigService,
		private chRef: ChangeDetectorRef,
		private _iconService: NzIconService,
		private _meService: MeService,
		private _locationService: LocationsService,
		private _router: Router,
		private _activatedRoute: ActivatedRoute,
		private _filterChangeService: FilterChangeService,
		private _locationsService: LocationsService,
		private _darkModeService: DarkModeService,
		public _filterDataChangeService: FilterChangeService,
		private _translate: TranslateService,
		private _tenantService: TenantService,
		private _locationGroupService: LocationGroupService,
		private store: Store,
	) {
		// effect(() =>{
		//     window.localStorage.setItem('darkMode',JSON.stringify(this.darkMode()));
		// })
		this._iconService.addIconLiteral(
			'ng-zorro:filter',
			IconSVG.filter('white'),
		);
		this._iconService.addIconLiteral('ng-zorro:home', IconSVG.home('white'));
		this._iconService.addIconLiteral(
			'ng-zorro:troubleshooting',
			IconSVG.troubleshooting('white'),
		);
		this._iconService.addIconLiteral(
			'ng-zorro:piggy_bank',
			IconSVG.piggy_bank('white'),
		);
		this._iconService.addIconLiteral(
			'ng-zorro:envelope',
			IconSVG.envelope('white'),
		);
		this._iconService.addIconLiteral('ng-zorro:graph', IconSVG.graph('white'));
		this._iconService.addIconLiteral(
			'ng-zorro:setting',
			IconSVG.setting('white'),
		);
		this._iconService.addIconLiteral(
			'ng-zorro:balance',
			IconSVG.balance('white'),
		);
		this._iconService.addIconLiteral(
			'ng-zorro:analytics',
			IconSVG.analytics('white'),
		);
		this._iconService.addIconLiteral('ng-zorro:users', IconSVG.users('white'));

		this._router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.currentRoute = event.urlAfterRedirects.split('/')[1];
			}
		});
	}

	openHandler(value: string, type: 'main' | 'sub'): void {
		// Solo i menu di primo livello (main) si chiudono a vicenda
		if (type === 'main') {
			// Chiudi tutti gli altri menu di primo livello
			const mainKeys = ['sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'sub6'];
			for (const key of mainKeys) {
				if (key !== value) {
					this.openMap[key] = false;
				}
			}
		}
		// I submenu (type === 'sub') possono essere aperti liberamente senza chiudere gli altri
	}
	/**
	 * Metodo di lifecycle Angular: inizializza il componente, imposta i filtri globali e dark mode.
	 */
	ngOnInit(): void {
		this.loadPersistedFilters();
		// Chiama solo la funzione di bootstrap principale
		this.checkMEValues();
		this._filterDataChangeService._myValueSubject.subscribe({
			next: (value: LocationData | any) => {
				this.syncFilterSummaryFromStorage();
			},
			error: (err: any) => {
				throw new Error(err);
			},
		});
		// Hidden sections
		const hiddenSectionsRaw = localStorage.getItem('hidden_sections');
		this.hiddenSectionsIds = hiddenSectionsRaw
			? JSON.parse(hiddenSectionsRaw).map((s: any) => String(s.id).trim())
			: [];
		// sidebarReady solo se listLocationsGroups è popolata
		// this.sidebarReady = this.listLocationsGroups.length > 0;
		// darkmode
		const bodyElement = document.documentElement;
		let getDarkMode = localStorage.getItem('darkMode');
		if (getDarkMode) {
			if (getDarkMode === 'dark') {
				this.bodyClass = this.availableDarkModeClasses[0];
				bodyElement.classList.add('dark');
			} else {
			}
		} else {
			this.bodyClass =
				this.availableDarkModeClasses[this.currentDarkModeClassIdx];
			this.changeDarkMode();
		}
		if (
			this.hiddenSectionsIds.includes('Overview') &&
			this._router.url.includes('overview')
		) {
			this._router.navigate(['/dashboard']);
		}
	}

	private GETTenant(): void {
		this._subscriptions.push(
			this._tenantService.GETTenant().subscribe({
				next: (res: Tenant | any) => {
					if (res.success) {
						// Popola la lista tenant solo per God
						this._tenantsList = res.data;
						this._showSelects = true;
						this.chRef.detectChanges();
					} else {
						console.log('error in res: ', res);
					}
				},
				error: (err: any) => {
					throw err;
				},
			}),
		);
	}

	// darkmode
	/**
	 * Cambia la modalità dark/light e aggiorna la classe del body.
	 */
	changeDarkMode() {
		this.themeSwitcher = !this.themeSwitcher;
		const bodyElement = document.documentElement;
		if (bodyElement) {
			this.currentDarkModeClassIdx = this.getNextDarkModeClassIdx();
			const nextClass =
				this.availableDarkModeClasses[this.currentDarkModeClassIdx];
			const activeClass =
				this.availableDarkModeClasses[this.getPrevDarkModeClassIdx()];
			bodyElement.classList.remove(activeClass);
			bodyElement.classList.add(nextClass);
			this.bodyClass = nextClass;
			localStorage.setItem('darkMode', nextClass);
			this._darkModeService.setDarkMode(nextClass);
		}
	}
	getPrevDarkModeClassIdx(): number {
		return this.currentDarkModeClassIdx === 0
			? this.availableDarkModeClasses.length - 1
			: this.currentDarkModeClassIdx - 1;
	}
	getNextDarkModeClassIdx(): number {
		return this.currentDarkModeClassIdx ===
			this.availableDarkModeClasses.length - 1
			? 0
			: this.currentDarkModeClassIdx + 1;
	}
	// darkmode
	async MEserviceCall(): Promise<Me | any> {
		try {
			const result = await firstValueFrom(this._meService.GETME());
			localStorage.setItem('Me', JSON.stringify(result));
			if (
				result &&
				result.data &&
				result.data.is_god === false &&
				Array.isArray(result.data.tenants) &&
				result.data.tenants.length === 1
			) {
				const tenant = result.data.tenants[0];
				if (tenant && tenant.id) {
					localStorage.setItem('tenant_id_selected', tenant.id);
					// Helpers.setRoleInLS(result?.data.tenants[0].role);
					Helpers.setRoleInLS();
					this._tenant = tenant.id;
					// Popola la lista tenant per non-God
					this._tenantsList = [tenant];
					this._showSelects = false;
					this.chRef.detectChanges();
				}
				if (tenant && tenant.locations_groups) {
					localStorage.setItem(
						'locations_groups_hidden',
						JSON.stringify(tenant.locations_groups || []),
					);
					this.listLocationsGroups = tenant.locations_groups.map(
						(id: string) => ({ id, name: id }),
					);
					this._showSelects = true; // Mostra sempre la select anche con un solo elemento
					// Se c'è un solo location group, selezionalo di default
					if (this.listLocationsGroups.length === 1) {
						this._locationGroup = this.listLocationsGroups[0].id;
						Helpers.setLocationGroupIDInLS(this._locationGroup);
						// Popola subito la lista location e attendi che sia completata
						await this.changeLocationGroupSelect(this._locationGroup);
						// Solo ora chiama getLocationGroupsByID
						this.getLocationGroupsByID();
						// Aggiorna subito hiddenSectionsIds per mostrare le sezioni corrette
						this.updateHiddenSectionsIds();
						return this._locationGroup;
					}
					// Aggiorna subito hiddenSectionsIds anche se ci sono più location groups
					this.updateHiddenSectionsIds();
					this.chRef.detectChanges();
					return this.listLocationsGroups.map((lg) => lg.id);
				} else {
					this._showSelects = true;
					this.listLocationsGroups = [];
					return null;
				}
			} else if (result && result.data && result.data.is_god === true) {
				this._showSelects = true;
				this.GETTenant();
				this.getLocationGroupsByID();
				return null;
			}
		} catch (error) {
			console.error('Errore durante la chiamata MEserviceCall:', error);
			throw error;
		}
	}
	async GETLocationsCall(locations: string): Promise<LocationS | any> {
		try {
			const result = await firstValueFrom(
				this._locationsService.GETLocations(locations),
			);
			this.availableSections = Helpers.getAvailabrSections();
			switch (Helpers.getBrand()) {
				case 'SISTELO':
					this._brandIconName = 'sistelo.svg';
					break;
				case 'LUMEN':
					this._brandIconName = 'lumen.png';
					break;
				default:
					break;
			}
			// return result?.data[0].id;
			return result;
		} catch (error) {
			console.error('Errore durante la chiamata a GETLocations:', error);
			throw error;
		}
	}
	async checkMEValues(): Promise<void> {
		try {
			await this.MEserviceCall();
			await this.restorePersistedFilters();
			this.saveFilterData(true);
		} catch (error) {
			console.error('Errore during checkMEValues():', error);
		}
	}
	/**
	 * Salvataggio dei dati della drawer
	 * se currentRoute è uguale a trend allora recupera dal LS since ed until
	 * e le rialloca per il salvataggio.
	 * (Questo perchè nella Trend page è disabilitato di default le select per le date)
	 */
	/**
	 * Aggiorna il filtro globale in NgRx Store e localStorage quando cambiano i parametri.
	 * Chiama anche i metodi di salvataggio e propagazione dei filtri.
	 */
	saveFilterData(preserveStoredDates: boolean = false) {
		this._drawerVisible = false;
		let locationGroupName: any;
		// salvataggio del location group name in LS
		// if(this._locationGroup === ""){
		//     this._locationGroup = Helpers.getDefaultLocationGroup();
		// }else{
		//     locationGroupName = this.listLocationsGroups.find(l => l.id === this._locationGroup)?.name;
		// }
		// Helpers.setLocationGroupNameInLS(locationGroupName!);
		// fine del salvataggio del location group name in LS
		this._locationGroupName = Helpers.getLocationGroupNameInLS();
		if (this.currentRoute != 'trend') {
			this.changeTimeRangeSelect(this._timeRange, preserveStoredDates);
			this._locationID = this._locationID == null ? '' : this._locationID;
			// Helpers.createLSLocationDate(this._locationGroup, this._locationID, this._since, this._until);
			Helpers.createLSLocationDateNew(
				this._tenant,
				this._locationGroup,
				this._locationID,
				this._since,
				this._until,
				this._timeRange,
			);
			this._filterChangeService.setMyValue(Helpers.getQueryTime());
		} else {
			const newSince = Helpers.getSince();
			const newUntil = Helpers.getUntil();
			// Helpers.createLSLocationDate(this._locationGroup, this._locationID, newSince, newUntil);
			Helpers.createLSLocationDateNew(
				this._tenant,
				this._locationGroup,
				this._locationID,
				newSince,
				newUntil,
				this._timeRange,
			);
			this._filterChangeService.setMyValue(Helpers.getQueryTime());
		}
		// Dopo aver salvato i dati nel localStorage, aggiorna lo stato globale NgRx
		this.store.dispatch(
			setFilter({
				filter: {
					since: this._since,
					until: this._until,
					location_id: this._locationID,
					time_range: this._timeRange,
					tenant: this._tenant,
					location_group: this._locationGroup,
					location: this._locationID,
				},
			}),
		);
	}
	open(): void {
		this.syncTimeRangeControl();
		this._drawerVisible = true;
		if (this.currentRoute == 'trend') {
			this._showRangePicker = false;
		} else {
			this._showRangePicker = true;
		}
	}
	close(): void {
		this._drawerVisible = false;
	}
	changeTimeRangeSelect(event: any, preserveStoredDates: boolean = false) {
		this._timeRange = event || this._timeRange;
		switch (event) {
			case 'LAST_7_DAYS':
				if (!preserveStoredDates) {
					this._since = Helpers.getTimeRangeInterval(7).start;
					this._until = Helpers.getTimeRangeInterval(7).end;
				}
				this._queryTime = `since=${this._since}&until=${this._until}`;
				this._showWEEKSelect = false;
				this.selectedDate = null;
				this.mode = '';
				Helpers.saveRangeMode(event);
				break;
			case 'LAST_30_DAYS':
				if (!preserveStoredDates) {
					this._since = Helpers.getTimeRangeInterval(30).start;
					this._until = Helpers.getTimeRangeInterval(30).end;
				}
				this._queryTime = `since=${this._since}&until=${this._until}`;
				this._showWEEKSelect = false;
				this.selectedDate = null;
				this.mode = '';
				Helpers.saveRangeMode(event);
				break;
			case 'LAST_180_DAYS':
				if (!preserveStoredDates) {
					this._since = Helpers.getTimeRangeInterval(180).start;
					this._until = Helpers.getTimeRangeInterval(180).end;
				}
				this._queryTime = `since=${this._since}&until=${this._until}`;
				this._showWEEKSelect = false;
				this.selectedDate = null;
				this.mode = '';
				Helpers.saveRangeMode(event);
				break;
			case 'LAST_365_DAYS':
				if (!preserveStoredDates) {
					this._since = Helpers.getTimeRangeInterval(365).start;
					this._until = Helpers.getTimeRangeInterval(365).end;
				}
				this._queryTime = `since=${this._since}&until=${this._until}`;
				this._showWEEKSelect = false;
				this.selectedDate = null;
				this.mode = '';
				Helpers.saveRangeMode(event);
				break;
			case 'WEEK':
				this._showWEEKSelect = true;
				this.mode = 'week';
				if (preserveStoredDates && this._since) {
					this.selectedDate = new Date(this._since);
				}
				Helpers.saveRangeMode(event);
				break;
			case 'MONTH':
				this._showWEEKSelect = true;
				this.mode = 'month';
				if (preserveStoredDates && this._since) {
					this.selectedDate = new Date(this._since);
				}
				Helpers.saveRangeMode(event);
				break;
			case 'QUARTER':
				this._showWEEKSelect = true;
				this.mode = 'quarter';
				if (preserveStoredDates && this._since) {
					this.selectedDate = new Date(this._since);
				}
				Helpers.saveRangeMode(event);
				break;
			default:
				break;
		}
	}
	onDateChange(date: Date): void {
		let _granularity: string = '';
		switch (this.mode) {
			case 'week':
				this._since = moment(date).isoWeekday(1).format('YYYY-MM-DD');
				this._until = moment(date).isoWeekday(7).format('YYYY-MM-DD');
				this._queryTime = `since=${this._since}&until=${this._until}`;
				_granularity = 'WEEK';
				break;
			case 'month':
				this._since = moment(date).startOf('month').format('YYYY-MM-DD');
				this._until = moment(date).endOf('month').format('YYYY-MM-DD');
				this._queryTime = `since=${this._since}&until=${this._until}`;
				_granularity = 'MONTH';
				break;
			case 'quarter':
				this._since = moment(date).startOf('quarter').format('YYYY-MM-DD');
				this._until = moment(date).endOf('quarter').format('YYYY-MM-DD');
				this._queryTime = `since=${this._since}&until=${this._until}`;
				_granularity = 'QUARTER';
				break;
			default:
				break;
		}
	}
	/**
	 * Serve a mostrare o nascondere le date selezionabili in base al mode
	 * week: dalla sett. precedente
	 * month: dal mese precedente
	 * year: dall'anno precedente
	 * @param current è la data proveniente dal datepicker
	 * @returns true / false, se true nascondo le restanti date se è false continuo
	 */
	disabledDate = (current: Date): boolean => {
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		switch (this.mode) {
			case 'week':
				// Calcola l'inizio della settimana corrente
				const startOfCurrentWeek = new Date(
					today.setDate(
						today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1),
					),
				);
				// Disabilita tutte le date a partire dall'inizio della settimana corrente
				return current >= startOfCurrentWeek;
			case 'month':
				const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
				// Disabilita tutte le date a partire dall'inizio del mese corrente
				return current >= startOfMonth;
			case 'year':
				const startOfYear = new Date(today.getFullYear(), 0, 1);
				// Disabilita tutte le date a partire dall'inizio dell'anno corrente
				return current >= startOfYear;
			case 'quarter':
				const startOfQuarter = new Date(
					today.getFullYear(),
					Math.floor(today.getMonth() / 3) * 3,
					1,
				);
				// Disabilita tutte le date a partire dall'inizio del trimestre corrente
				return current >= startOfQuarter;
			default:
				return false;
		}
	};
	onChangeData(result: Date[]): void {
		const start = moment(result[0].getTime()).format('YYYY-MM-DD');
		const end = moment(result[1].getTime()).format('YYYY-MM-DD');
		this._queryTime = `since=${start}&until=${end}`;
		this._since = start;
		this._until = end;
	}

	private getLocationGroupsByID(): void {
		if (Helpers.isGod()) {
			this._subscriptions.push(
				this._locationGroupService.GETLocationGroupsAll().subscribe({
					next: (response: any) => {
						if (response.success) {
							this.listLocationsGroups = response.data;
							this.sidebarReady = this.listLocationsGroups.length > 0;
							this.updateHiddenSectionsIds();
							this.chRef.detectChanges(); // Forza aggiornamento UI
						} else {
							console.log('error in res: ', response);
						}
					},
					error: (err: any) => {
						throw new Error(err);
					},
				}),
			);
		} else {
			this._subscriptions.push(
				this._locationGroupService
					.GETLocationGroupById(Helpers.getLocationsGroupsHiddenID()[0])
					.subscribe({
						next: (response: any) => {
							if (response.success) {
								// Popola sempre la lista anche per non-God
								let groups = response.data.data || [];
								// Se l'array è vuoto, mantieni la lista già popolata da MEserviceCall
								if (
									groups.length === 0 &&
									this.listLocationsGroups.length > 0
								) {
									groups = this.listLocationsGroups;
								} else if (groups.length > 0 && typeof groups[0] === 'string') {
									groups = groups.map((id: string) => ({ id, name: id }));
								}
								this.listLocationsGroups = groups;
								this.sidebarReady = this.listLocationsGroups.length > 0;
								localStorage.setItem(
									'hidden_sections',
									JSON.stringify(response.data.hidden_sections || []),
								);
								this.updateHiddenSectionsIds();
								this.chRef.detectChanges(); // Forza aggiornamento UI
							} else {
								console.log('error in res: ', response);
							}
						},
						error: (err: any) => {
							throw new Error(err);
						},
					}),
			);
		}
	}

	/**
	 * Gestisce la selezione del tenant e aggiorna i gruppi location disponibili.
	 */
	changeTenantSelect(event: string) {
		this._tenant = event;
		Helpers.setTenantInLS(event);
		this.getLocationGroupsByID();
	}
	/**
	 * Gestisce la selezione del gruppo location e aggiorna le location disponibili.
	 */
	// Rende changeLocationGroupSelect async e restituisce una Promise
	async changeLocationGroupSelect(event: any): Promise<void> {
		Helpers.setLocationGroupIDInLS(event);
		this._locationGroup = event;
		return new Promise((resolve, reject) => {
			this._subscriptions.push(
				this._locationGroupService.GETLocationsAll(event).subscribe({
					next: (response: LocationSListData | any) => {
						if (response) {
							this.listLocationsID = response?.data;
							this.listLocationsID.unshift({ id: '*', name: 'All Locations' });
							this._showMonitoring = Helpers.checkIfLocationsAreMoreThanOne(
								response.data,
							);
							// Se c'è una sola location reale, selezionala automaticamente
							const realLocations = this.listLocationsID.filter(
								(l) => l.id !== '*',
							);
							if (realLocations.length === 1) {
								this._locationID = realLocations[0].id;
								Helpers.setLocationIDInLS(this._locationID);
							}
							this.chRef.detectChanges();
							resolve();
						} else {
							console.log('error in res: ', response);
							reject();
						}
					},
					error: (err: any) => {
						reject(err);
					},
				}),
			);
		});
	}
	/**
	 * Gestisce la selezione della location e aggiorna il nome e i filtri associati.
	 */
	changeLocationIDSelect(event: string) {
		Helpers.setLocationIDInLS(event);
		this._locationID = event;
		// this._locationID = event;
		const location = this.listLocationsID.find(
			(l: LocationS) => l.id === event,
		)?.name;
		this._locationName = location || '';
		Helpers.setLocationNameInLS(this._locationName);
		// const location = this.listLocationsID.find(l => l.id === event)?.name;
		// Helpers.setLocationNameInLS(location!);
		// Helpers.createLSLocationDate(Helpers.getDefaultLocationGroup(), Helpers.getDefaultLocation(), this._since, this._until);
	}

	private loadPersistedFilters(): void {
		const persistedFilters = this.getPersistedFilters();
		this._tenant = persistedFilters.tenant || this._tenant;
		this._locationGroup = persistedFilters.locationGroup || this._locationGroup;
		this._locationID = persistedFilters.locationId || this._locationID;
		this._location_id = this._locationID;
		this._since = persistedFilters.since || this._since;
		this._until = persistedFilters.until || this._until;
		this._timeRange = persistedFilters.timeRange || this._timeRange;
		this.syncFilterSummaryFromStorage();
	}

	private syncFilterSummaryFromStorage(): void {
		this._locationName = Helpers.getLocationNameInLS();
		this._locationGroupName = Helpers.getLocationGroupNameInLS();
		this._periodToShow = Helpers.showSinceUntilPeriod();
		this._location_id = Helpers.getDefaultLocation();
		this._locationID = this._locationID || this._location_id;
		this._since = Helpers.getSince() || this._since;
		this._until = Helpers.getUntil() || this._until;
		this._timeRange = this.resolvePersistedTimeRange();
		this.changeTimeRangeSelect(this._timeRange, true);
	}

	private getPersistedFilters(): PersistedSidebarFilters {
		return {
			tenant: Helpers.getTenantIDInLS(),
			locationGroup:
				localStorage.getItem('location_group_id_selected') ||
				Helpers.getDefaultLocationGroup(),
			locationId:
				localStorage.getItem('location_id_selected') ||
				Helpers.getDefaultLocation(),
			timeRange: this.resolvePersistedTimeRange(),
			since: Helpers.getSince(),
			until: Helpers.getUntil(),
		};
	}

	private async restorePersistedFilters(): Promise<void> {
		const locationGroupToRestore = this.getRestorableLocationGroup();
		if (!locationGroupToRestore) {
			return;
		}

		if (
			this._locationGroup !== locationGroupToRestore ||
			this.listLocationsID.length === 0
		) {
			await this.changeLocationGroupSelect(locationGroupToRestore);
		}

		const locationIdToRestore = this.getRestorableLocationId();
		if (locationIdToRestore) {
			this.changeLocationIDSelect(locationIdToRestore);
		}

		this._locationGroup = locationGroupToRestore;
		this._location_id = this._locationID;
		this.changeTimeRangeSelect(this._timeRange, true);
	}

	private getRestorableLocationGroup(): string {
		const persistedLocationGroup =
			this._locationGroup || Helpers.getDefaultLocationGroup();
		if (
			persistedLocationGroup &&
			(this.listLocationsGroups.length === 0 ||
				this.listLocationsGroups.some(
					(locationGroup) => locationGroup.id === persistedLocationGroup,
				))
		) {
			return persistedLocationGroup;
		}

		if (this.listLocationsGroups.length === 1) {
			return this.listLocationsGroups[0].id;
		}

		return '';
	}

	private getRestorableLocationId(): string {
		const persistedLocationId = this._locationID || Helpers.getDefaultLocation();
		if (
			persistedLocationId &&
			this.listLocationsID.some((location) => location.id === persistedLocationId)
		) {
			return persistedLocationId;
		}

		if (this.listLocationsID.some((location) => location.id === '*')) {
			return '*';
		}

		return this.listLocationsID[0]?.id || '';
	}

	private resolvePersistedTimeRange(): string {
		const savedTimeRange = Helpers.getSavedTimeRange();
		if (savedTimeRange) {
			return savedTimeRange;
		}

		const storedMode = Helpers.getRangeMode();
		if (storedMode) {
			return storedMode;
		}

		const storedSince = Helpers.getSince();
		const storedUntil = Helpers.getUntil();
		if (!storedSince || !storedUntil) {
			return this._timeRange;
		}

		const fixedRanges = [
			'LAST_7_DAYS',
			'LAST_30_DAYS',
			'LAST_180_DAYS',
			'LAST_365_DAYS',
		] as const;

		for (const range of fixedRanges) {
			const days = this.getTimeRangeDays(range);
			const interval = Helpers.getTimeRangeInterval(days);
			if (interval.start === storedSince && interval.end === storedUntil) {
				return range;
			}
		}

		return this._timeRange;
	}

	private getTimeRangeDays(
		range: 'LAST_7_DAYS' | 'LAST_30_DAYS' | 'LAST_180_DAYS' | 'LAST_365_DAYS',
	): number {
		switch (range) {
			case 'LAST_7_DAYS':
				return 7;
			case 'LAST_30_DAYS':
				return 30;
			case 'LAST_180_DAYS':
				return 180;
			case 'LAST_365_DAYS':
				return 365;
		}
	}

	private syncTimeRangeControl(): void {
		this._timeRange = this.resolvePersistedTimeRange();
		this.changeTimeRangeSelect(this._timeRange, true);
		this.chRef.detectChanges();
	}

	compareSelectValue = (first: string | null, second: string | null): boolean =>
		String(first || '') === String(second || '');
	// private checkForSelect() {
	//     if (Helpers.getLocationGroupsByID()) {
	//         this.listLocationsGroups = Helpers.getLocationGroupsByID();
	//     } else { }
	// }
	/**
	 * Effettua il logout dell'utente tramite Keycloak.
	 */
	public logout() {
		KeycloakConfig.keycloakLogout();
		setTimeout(() => {
			this.updateHiddenSectionsIds(); // AGGIUNTA: aggiorna dopo logout
		}, 500);
	}
	handleCancel() {
		this._isVisible = false;
	}
	handleOk() {
		window.open(environment.oldVersionDashboardPath, '_blank');
		this._isVisible = false;
	}
	oldVersion() {
		this._isVisible = true;
	}
	/** Handle side bar on page resize */
	/* A decorator that allows you to listen to events on the host element. */
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		if (event.target.innerWidth < 900) {
			this.isCollapsed = true;
		}
		if (event.target.innerWidth <= 574) {
			this.sideBarWidth = 0;
		} else if (event.target.innerWidth < 900 && event.target.innerWidth > 574) {
			this.sideBarWidth = 130;
		} else {
			if (!this.isCollapsed) {
				this.sideBarWidth = 260;
			} else {
				this.sideBarWidth = 130;
			}
		}
	}
	ngAfterViewInit() {
		// this._loaderService.showLoader(false);
		// register translations
		// this.translationService.loadTranslations(enLang, itLang);
		// this.chRef.detectChanges();
		this.sidebar = true;

		// // Hanlde sidebar
		if (window.innerWidth < 900) {
			this.isCollapsed = true;
		}
		if (window.innerWidth <= 574) {
			this.sideBarWidth = 0;
		} else if (window.innerWidth < 900 && window.innerWidth > 574) {
			this.sideBarWidth = 130;
		} else {
			if (!this.isCollapsed) {
				this.sideBarWidth = 260;
			} else {
				this.sideBarWidth = 130;
			}
		}
	}
	/**
	 * Metodo di lifecycle Angular: cleanup delle subscription.
	 */
	ngOnDestroy(): void {
		this._subscriptions.forEach((n: Subscription) => n.unsubscribe());
	}
	/**
	 * Restituisce la lista degli id delle sezioni nascoste.
	 */
	get hiddenSectionsIdsList(): string[] {
		// Normalizza sempre gli id a stringa e rimuove eventuali spazi
		return this.hiddenSectionsIds.map((id) => String(id).trim());
	}
	/**
	 * Controlla se una sezione sidebar è visibile, confrontando in modo robusto (stringa) l'id.
	 */
	isSectionVisible(section: any): boolean {
		return !this.hiddenSectionsIdsList.includes(String(section).trim());
	}
}
